// import SvgIcon from "@/components/common/SvgIcon";
import { Avatar, Typography } from "@/components/kit";
import { Table } from "@/components/kit/Table/Table";
import { FC } from "react";
import useStoreMe from "@/hooks/store/useStoreMe";
import moment from "moment-timezone";
import { IUserResponse } from "../types";
import { useNavigate } from "react-router-dom";
import SvgIcon from "@/components/common/SvgIcon";
import PermissionGate from "@/components/PermissionGate";
import { PERMISSIONS } from "@/constants/permissions";

interface ITableRowProps {
  user: IUserResponse;

  onViewDetails: (user: IUserResponse) => void;
  setSelectedUser: (user: IUserResponse) => void;
}

const MspAdminRow: FC<ITableRowProps> = ({ user, setSelectedUser }) => {
  const navigate = useNavigate();
  const {
    id,
    firstName,
    lastName,
    email,
    lastLogin,
    profile,
    displayName,
    preferredMfaType,
    mfaActive,
  } = user;
  const { me } = useStoreMe();
  return (
    <Table.RowBody
      onClick={() => navigate(`/admins/${id}`)}
      key={id}
      className="flex w-full h-[41px] border-b group hover:bg-gray-1100 cursor-pointer transition-colors"
    >
      <Table.Cell
        name="Name"
        index={0}
        className="flex items-center !py-2 gap-2 !px-4 bg-red-200"
      >
        {typeof profile === "string" && profile ? (
          <Avatar size="sm" name={`${firstName} ${lastName}`} src={profile} />
        ) : (
          <Avatar size="sm" name={`${firstName} ${lastName}`} />
        )}
        <Typography
          hasTitle
          variant="BodyPlus2-medium"
          className=" !font-bold !truncate"
          color="!text-text-600"
        >
          {firstName} {lastName}
        </Typography>
        {me?.id === user.id && (
          <Typography
            variant="Caption2-Regular"
            className=" rounded-[6px]  p-1.5 bg-blue-100"
          >
            You
          </Typography>
        )}
      </Table.Cell>
      <Table.Cell
        name="Display name"
        index={1}
        className="flex items-center gap-2"
      >
        <Typography hasTitle variant="Caption1-Regular" className="!truncate">
          {displayName ? displayName : "-"}
        </Typography>
      </Table.Cell>
      <Table.Cell
        name="Email"
        className="h-auto flex items-center gap-3"
        index={2}
      >
        <Typography hasTitle variant="Caption1-Regular" className="!truncate">
          {email}
        </Typography>
      </Table.Cell>
      <Table.Cell name="MFA" index={3} className=" flex items-center gap-2">
        {mfaActive ? (
          <div>
            ✅ Enabled (
            {preferredMfaType === "totp"
              ? "TOTP"
              : preferredMfaType === "email"
                ? "Email OTP"
                : "WebAuthn"}
            )
          </div>
        ) : (
          <div>⏳ Not Set Up</div>
        )}
      </Table.Cell>
      <Table.Cell name="Last login" index={4}>
        {lastLogin ? moment(lastLogin).format("D MMM , YYYY @ h:mm A") : "-"}
      </Table.Cell>
      <Table.Cell name="Actions" index={5}>
        {user.id !== me?.id ? (
          <PermissionGate permission={PERMISSIONS.USERS_REVOKE}>
            <SvgIcon
              onClick={(e) => {
                e.stopPropagation();
                setSelectedUser(user);
              }}
              iconName="revoke"
              fill="fill-text-600"
              width={20}
              height={20}
            />
          </PermissionGate>
        ) : (
          "--"
        )}
      </Table.Cell>
    </Table.RowBody>
  );
};

export default MspAdminRow;
